import { render, staticRenderFns } from "./Expenditure.vue?vue&type=template&id=62fcf48d"
import script from "./Expenditure.vue?vue&type=script&lang=js"
export * from "./Expenditure.vue?vue&type=script&lang=js"
import style0 from "./Expenditure.vue?vue&type=style&index=0&id=62fcf48d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports